import { ITimestampedAmount } from './timestamped-amount';
import { IdName } from '../../../shared';

export class EmployeeSalaryDetails {

    employee: IdName;
    hours: number;
    invoices: ITimestampedAmount[];
    totals: ITimestampedAmount[];
    commissions: ITimestampedAmount[];
    hourlySalaries: ITimestampedAmount[];
    deductions: ITimestampedAmount[];
    reimbursements: ITimestampedAmount[];
    sales: ITimestampedAmount[];
    averagePerHour: number;

    constructor(data: any) {
        Object.assign(this, data);
        this.formatDeductions();
    }

    private formatDeductions() {
        if(this.deductions) {
            this.deductions.forEach(d => {
                d.amount = -d.amount;
            });
        }
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/employees/shared/models/employee-salary-details.ts